<mat-card>
  <div #exportContent>
    <div class="header">
      <div class="title">SAIFI and SAIDI Values ({{ yearParam() }})</div>
      <button class="header-btn" mat-icon-button data-html2canvas-ignore (click)="export()">
        <vulcan-icon size="24px" icon="download"></vulcan-icon>
      </button>
    </div>
    <mat-card-content>
      <div class="flex-row">
        <div class="label">SAIFI</div>
        <div class="flex-column">
          <div><strong>{{ saifiWith() }}</strong> {{ saifiMedText }}</div>
          <div><strong>{{ saifiWithout() }}</strong> {{ saifiNoMedText }}</div>
        </div>
      </div>
      <div class="flex-row">
        <header class="label">SAIDI</header>
        <div class="flex-column">
          <div><strong>{{ saidiWith() }}</strong> {{ saidiMedText }}</div>
          <div><strong>{{ saidiWithout() }}</strong> {{ saidiNoMedText }}</div>
        </div>
      </div>
      <p>
        {{ disclaimer }}
      </p>
    </mat-card-content>
  </div>
</mat-card>
